import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';

function CardsSelectBox(props ) {
    let cards: Record<string, string> = typeof props?.cards === 'object' ? props.cards : {};
    const [selectedCard, setSelectedCard] = useState<string>('');
    const [allCreditCares, setAllCreditCares] = useState([]);
    const [allAllowedCreditCares, setAllAllowedCreditCares] = useState([]);

    const AllCreditCards = () => {
        let options = [];

        allCreditCares.forEach( item => {
            if ( props.validateItem( item ) ) {
                options.push( <option key={item.key} value={item.key}>{item.value}</option> );
            }
        } );

        if ( ! options.length ) {
            options.push( <option key='no_card_found' value=''>{__( 'Select a card', 'dokan' )}</option> );
        }

        return <select className='dokan-mangopay-credit-cards-content' name="dokan_mangopay_card_type" value={selectedCard} onChange={ e => setSelectedCard( e.target.value ) }>{options}</select>
    }

    useEffect(() => {
        if ( Object.keys( cards ).length ) {
            let allCards = Object.keys( cards ).map( item => {
                return {
                    key: item,
                    value: cards[item]
                }
            } );

            let allAllowerCards = allCards.filter( item => props.validateItem( item ) );

            setSelectedCard( allAllowerCards.length ? allAllowerCards[0].key : '' );
            setAllAllowedCreditCares(allAllowerCards);
            setAllCreditCares( allCards );
        }
    },[])

    useEffect(() => {
        props.onChange( selectedCard );
    }, [selectedCard]);

    return (
        <div className='dokan-mangopay-credit-cards'>
            {Object.keys( cards ).length
                ?
                AllCreditCards()
                : __( 'No cards found', 'dokan' )
            }
        </div>
    );
}

export default CardsSelectBox;
